import { Action, createReducer, on } from '@ngrx/store';
import { generalConsultActions } from './general.action';
import { GeneralConsultState, generalConsultIS } from './general.state';

const generalConsultRegister = createReducer(
  generalConsultIS,
  on(generalConsultActions.setPatientAction, (state, { patient }) => ({
    ...state,
    patient,
  })),

  on(generalConsultActions.setSavingAction, (state, { saving }) => ({
    ...state,
    saving,
  })),

  on(generalConsultActions.addToSavedAction, (state, { value }) => {
    const newState = { ...state };
    newState.totalSaved += value;
    if (newState.totalSaved === 7) {
      newState.saving = false;
      newState.totalSaved = 0;
      newState.save = true;
    }
    return newState;
  }),

  on(generalConsultActions.setSaveAction, (state, { save }) => ({
    ...state,
    save,
  })),

  on(generalConsultActions.setAllDefaultAction, () => generalConsultIS)
);

export function generalConsultReducer(
  state: GeneralConsultState,
  action: Action
): any {
  return generalConsultRegister(state, action);
}
